import { apiGet, apiDelete, apiPost, apiPut } from './fetch';
import { ReportId, ReportMap, Report } from 'types';
import { baseUrl } from './baseUrl';

export const getReports = async () =>
    await apiGet<ReportMap>(`${baseUrl}/reports`)
;

export const deleteReport = async (reportId: ReportId) =>
    await apiDelete<boolean>(`${baseUrl}/reports/${reportId}`)
;

export const saveNewReport = async (report: Report) =>
    await apiPost<Report, ReportId>(`${baseUrl}/reports`, report)
;

export const updateReport = async (report: Report) =>
    await apiPut<Report>(`${baseUrl}/reports/${report.reportId}`, report)
;



// WEBPACK FOOTER //
// ./src/api/reports.ts